import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { AccessDenied, useAlerts, useUsers } from "common";
import { OISProvider } from "./services/OISService/OISProvider";
import OISPage from "./components/OIS/OISPage";

export const AppRoutes = () => {
  const location = useLocation();
  const { accessDenied } = useUsers();
  const { t } = useTranslation();
  const { alert, clearAlert } = useAlerts();

  useEffect(() => {
    // Clear previous alerts when navigation moves to a new page to reset the `pageAccessDenied` flag.
    // Ensures Access Denied components do not constantly override the below <Routes /> hierarchy.
    if (alert.pageAccessDenied) clearAlert();

    // Disabling as we only want to monitor react-router location changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  // Prevent access if the user is not authorized to use the application
  if (accessDenied) {
    return <AccessDenied supportEmail={t(`app.supportEmail`)} />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <OISProvider>
            <OISPage />
          </OISProvider>
        }
      />
    </Routes>
  );
};
